<template>
  <div>
    <div class="hezuohuoban">
      <!--top-->
      <div class="top">
        <!--nav-->
        <Nav></Nav>
        <!--nav-end-->
        <!--banner-->
        <div class="banner">
          <div class="layui-carousel" id="test10">
            <div class="layui-cen" carousel-item="">
              <div>
                <img
                  src="@s/data/uploads/20180816/ef6d6c0f4c1c7b53d27db4ae128927da.jpg"
                />
              </div>
            </div>
          </div>
        </div>
        <!--banner-end-->
      </div>
      <!--top-end-->

      <!--about-center-->
      <div class="aaa">
        <div class="layui-tab" v-if="nav">
          <div class="layui-tab-a">
            <ul class="layui-tab-title">
              <li :class="{ 'layui-this': tab == i }" v-for="(item,i) in nav[2].children" :key="i">{{item.module}}</li>
            </ul>
          </div>
          <div class="layui-tab-content">
            <div
              class="about women-cen layui-tab-item"
              v-for="(item,i) in nav[2].children"
              :key="item.code"
              :class="{ 'layui-show': tab == i }"
            >
            <div v-if="introduction[item.code]" v-html="introduction[item.code].introduction"></div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>

    <Backtop></Backtop>
  </div>
</template>

<script>
import Nav from "@c/Main/Nav/index.vue";
import Footer from "@c/Main/Footer/index.vue";
import Backtop from "@c/Main/Backtop/index.vue";
import { configQuery } from "@/Apis/functions/user";
export default {
  name: "brand",
  components: { Nav, Footer, Backtop },
  data() {
    return {
      tab: this.$route.params.tab || 0,
      nav: this.$store.state.menuBar,
      introduction: {}
    };
  },
  methods: {
    initData(){
       this.nav && this.nav[2].children.forEach(item => {
         configQuery({
            merchantId: "dwj",
            code: item.code,
          }).then((result) => {
            if (result.status == 200) {
              this.$set(this.introduction,item.code,result.data)
            }
          });
       })
    }
  },
  watch:{
    '$store.state.menuBar'(val){
      this.nav = val
      this.$nextTick(() => {
        this.initData()
        layui.use("element", function () {
          var $ = layui.jquery,
            element = layui.element; //Tab的切换功能，切换事件监听等，需要依赖element模块
        });
      })
    }
  },
  mounted() {
    if(this.nav){
      this.initData()
      layui.use("element", function () {
        var $ = layui.jquery,
          element = layui.element; //Tab的切换功能，切换事件监听等，需要依赖element模块
      });
    }
    layui.use(["carousel", "form"], function () {
      var carousel = layui.carousel;
      //鍥剧墖杞挱
      carousel.render({
        elem: "#test10",
        width: "100%",
        height: "6.70rem",
        interval: 5000,
      });
    });
  },
};
</script>
<style>
@import "~@/static/skin/web/css/qixia.css";
@import "~@/static/skin/web/css/dawanjai.css";
@import "~@/static/skin/web/css/erji.css";
</style>
